module.exports = __webpack_public_path__ + "img/spinner.f74252ef.svg";